export const API_URL = "https://twojaopiekunka.pl/api";
